/**
 * Related News Swiper
 * Implements Swiper.js for related news module on screens < 1240px
 */

import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

class RelatedNewsSwiper {
    constructor() {
        this.swiperInstance = null;
        this.init();
    }

    init() {
        const container = document.querySelector('.related-news-swiper');

        if (!container) {
            return;
        }

        this.container = container;

        // Always initialize Swiper
        this.initSwiper();
    }

    initSwiper() {
        if (this.swiperInstance || !this.container) {
            return;
        }

        this.swiperInstance = new Swiper(this.container, {
            modules: [Navigation],
            slidesPerView: 'auto',
            spaceBetween: 24, // Equivalent to gap-13.5 (13.5 * 4 = 54px)
            grabCursor: true,
            // Enable touch events on desktop too
            simulateTouch: true,
            // Prevent clicks during swipe
            preventClicks: true,
            preventClicksPropagation: true,
            slideToClickedSlide: false,
            // Navigation
            navigation: {
                nextEl: '.news-nav-next',
                prevEl: '.news-nav-prev',
            },
            // Responsive breakpoints
            breakpoints: {
                // Desktop (1240px and up)
                640: {
                    slidesPerView: 2,
                },
                1240: {
                    slidesPerView: 4,
                    spaceBetween: 54,
                    freeMode: false,
                    slidesPerGroup: 1,
                    slidesOffsetAfter: 0,
                }
            }
        });
    }

    destroySwiper() {
        if (this.swiperInstance) {
            this.swiperInstance.destroy(true, true);
            this.swiperInstance = null;
        }
    }
}

export default RelatedNewsSwiper;